import { CARACTERISTICA_FIELDS } from '~/enums/caracteristicas'

export const getEmptyFeatureFields = (formValues: Record<string, unknown>) =>
  CARACTERISTICA_FIELDS.filter((field) => !formValues[field])
